module.exports = __webpack_public_path__ + "static/media/content_hero.8f980403.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/content_hero.png
// module id = 273
// module chunks = 0